import { createFileRoute } from '@tanstack/react-router'
import { NormalizationsPage } from '../../../components/NormalizationsPage'

export const Route = createFileRoute('/$org/normalizations/')({
  component: NormalizationsPageRoute,
})

function NormalizationsPageRoute() {
  return <NormalizationsPage />
}
